import { yupResolver } from '@hookform/resolvers/yup'
import { errorMessage } from '@sparling/financial-common'
import * as yup from 'yup'

const FLOAT_REGEX = /^[+-]?\d+(\.\d+)?$/

export const CreateSfBankAccountFeesResolver = yupResolver(
  yup
    .object()
    .shape({
      moneyInFees: yup
        .string()
        .nullable()
        .matches(FLOAT_REGEX, { message: errorMessage.NUMBERS, excludeEmptyString: true }),

      moneyOutFees: yup
        .string()
        .nullable()
        .matches(FLOAT_REGEX, { message: errorMessage.NUMBERS, excludeEmptyString: true }),

      wireFees: yup
        .string()
        .nullable()
        .matches(FLOAT_REGEX, { message: errorMessage.NUMBERS, excludeEmptyString: true }),
    })
    // eslint-disable-next-line func-names
    .test('at-least-one', errorMessage.EMPTY_FIELD, function (value) {
      return (
        !!value.moneyInFees?.toString().trim() ||
        !!value.moneyOutFees?.toString().trim() ||
        !!value.wireFees?.toString().trim()
      )
    }),
)
